<template>
  <header class="pt-5 pb-10 mb-10 md:mb-8 lg:mb-10 bg-polgrey">
    <div class="container px-8 mx-auto">
      <div class="ie-hero-heading flex flex-col items-left md:items-center mt-2 mb-2 sm:flex-row jusitfy-between md:mb-6">
        <div class="w-6/6 w-auto md:w-3/6 lg:w-2/6">
        <Logo alt="Post Office Credit Card QuickCheck" class="inline-block w-16 mr-5 h-14"></Logo>
          <span class="text-xl md:text-2xl font-bold align-text-middle">Credit Card QuickCheck</span>
        </div>
        <div class="inline-flex mt-2 mb-3"></div>
      </div>
    </div>
    <div class="flex flex-col">
    <div class="ie-hero-height container px-8 mx-auto">
      <main class="flex flex-col pt-0 pb-2 sm:flex-row jusitfy-between">
          <div class="flex flex-col items-center text-left lg:w-8/12 md:w-6/12 sm:items-start">
            <div>
              <h1 class="ie-hero-title text-4xl leading-none sm:leading-tight md:text-5xl lg:text-5.5xl mt-4 font-bold leading-tight mb-6">
                <div v-if="offer.provider !== 'CreditKarma' && offer.provider !== 'CompareTheMarket'">
                  Here's the Post Office Credit Card you viewed on {{ offer.provider }}
                </div>
                <div v-if="offer.provider === 'CreditKarma'">
                  Here's the Post Office Credit Card you viewed on Credit Karma
                </div>
                <div v-if="offer.provider === 'CompareTheMarket'">
                  Here's the Post Office Credit Card you viewed on Compare the Market
                </div>
              </h1>
              <h2 class="mb-0 text-lg sm:text-2xl text-secondary sm:mb-6 btGuratanteedFlagEnabled">
                To see if you’ll be accepted, please continue below.
              </h2>
              <!-- BT Guaranteed enabled -->
              <h2 v-if="balanceTransferRequestedDecision == 'Y' && creditRequested.creditAmount >= 50" class="mb-0 text-lg sm:text-2xl text-secondary sm:mb-6 btGuratanteedFlagEnabled">
                Your £{{creditRequested.creditAmount}} balance transfer will also be confirmed. 
              </h2>
            </div>
            <div class="mt-8" v-if="!isSmallScreen()">
              <h3 class="mb-6 text-2xl font-bold">What happens next:</h3>
              <NumberedList :items="whatsNext"/>
            </div>
          </div>
          <div class="mt-8 sm:mb-0 md:w-6/12 sm:mt-0 lg:w-4/12 md:ml-20">
              <div class="relative py-6 bg-white rounded-lg shadow-full md:ml-9">
                <div v-if="offer.provider" class="absolute top-0 right-0 block p-6">
                  <div v-if="offer.provider !== 'MoneySavingExpert'">
                    <img class="w-24" :src="require(`@/v2/assets/images/logos/${lower(offer.provider)}.png`)" :alt="offer.provider">
                  </div>
                </div>
                <!-- Card image and name -->
                <div :class="{ 'mt-8': offer.provider }" class="mx-4 text-center border-b" v-if="offer.cardDesign">
                  <img class="object-contain w-3/6 mx-auto" :src="require(`@/v2/assets/images/cards/${offer.cardDesign}.png`)" alt="Post Office Credit Cards">
                  <h3 class="px-6 mt-4 mb-2 text-2xl font-bold leading-tight lg:px-12">{{ offer.name }}</h3>
                </div>
                <!-- Card fees -->
                <div class="mx-4" v-if="isset(offer.apr)">
                  <p class="px-2 mt-4 text-sm">Representative APR (variable)</p>
                  <h4 class="px-2 text-4xl font-bold">{{ toFixed(offer.apr, 1) }}%</h4>
                </div>
                <div class="flex flex-row justify-center mx-4 text-left">
                  <div class="w-2/3 px-2" v-if="isset(offer.balanceTransferOfferDuration)">
                    <div class="">
                      <p class="mt-4 text-sm">Balance transfer offer duration</p>
                      <h4 class="mb-2 text-2xl font-bold">{{ offer.balanceTransferOfferDuration }}</h4>
                    </div>
                  </div>
                  <div class="w-1/3" v-if="isset(offer.transferFee)">
                      <p class="mt-4 text-sm">Transfer fee</p>
                      <h4 class="mb-2 text-2xl font-bold">{{ parseFloat(offer.transferFee) }}%</h4>
                  </div>
                </div>
                <div class="flex flex-row justify-center mx-4 text-left">
                  <div class="w-2/3 px-2" v-if="isset(offer.purchaseOfferDuration)">
                    <div class="">
                      <p class="h-10 mt-4 text-sm">Purchase offer duration</p>
                      <h4 class="mb-2 text-2xl font-bold">{{ offer.purchaseOfferDuration }}</h4>
                    </div>
                  </div>
                  <div class="w-1/3" v-if="isset(offer.purchaseOfferAPR)">
                      <p class="h-10 mt-4 text-sm leading-tight">Purchase offer rate p.a.</p>
                      <h4 class="mb-2 text-2xl font-bold">{{ parseFloat(offer.purchaseOfferAPR) }}%</h4>
                  </div>
                </div>
              </div>
          </div>
      </main>
    </div>
    <div class="px-10 mx-auto mt-12 lg:mt-4" v-if="isSmallScreen()">
      <h3 class="mb-6 text-2xl font-bold">What happens next:</h3>
      <NumberedList :items="whatsNext"/>
    </div>
</div>
    <div class="container w-11/12 px-8 mx-auto md:mt-2">
      <div v-if="isset(offer.apr)" class="mt-4 mb-6 lg:my-8">
        <RepresentitiveExample :apr-rate="parseFloat(offer.apr)"/>
      </div>
      <div class="mb-6 text-lg font-bold text-center">
        Capital One is the exclusive lender and issuer of all new Post Office Credit Cards, for which Post Office acts as a credit broker.
      </div>
      <div class="mx-2 text-center text-md">
        <div class="inline-block w-auto font-bold uppercase">
          <Notice text="To be eligible for our credit card, you must be over 18 and be a UK resident"></Notice>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

// svgs
import Logo from '@/v2/assets/images/logos/post-office.svg'

import Notice from '@/v2/components/elements/Notice'
import NumberedList from '@/v2/components/elements/AggregatorFlow/NumberedList'
import mixins from '@/v2/mixins'
import RepresentitiveExample from '@/v2/components/elements/RepresentitiveExample'

export default {
  name: 'AggregatorOffer',
  mixins: [mixins],
  props: {
    offer: Object,
    creditRequested: Object,
    balanceTransferRequestedDecision: String
  },
  data(){
    return {
      whatsNext: [
        `We'll check your eligibility without affecting your credit score.`,
        `We'll give you a decision in 60 seconds.`,
        `Complete your application if you're eligible for our credit card.`
      ]
    }
  },
  components: {
    Logo,
    Notice,
    NumberedList,
    RepresentitiveExample
  }
}
</script>